import { create } from 'zustand';
import { HomePageYourMemberCardPropertiesModel } from '@/services/platform/api/model';

interface MemberCardState {
  cmsProperties: HomePageYourMemberCardPropertiesModel | null;
  setCmsProperties: (props: HomePageYourMemberCardPropertiesModel | null) => void;
}

export const useMemberCardStore = create<MemberCardState>(set => ({
  cmsProperties: null,
  setCmsProperties: props => set({ cmsProperties: props }),
}));
